import { getNestedValueKey } from "../../utils/objects/nestedValue"

/**
 * The form values a condition reads, taken from the scope the element is bound to.
 *
 * A field rendered inside a line belongs to that line — `FormElem` reads its
 * value with `getNestedValueKey(s, path, id)` — so a predicate written on it has
 * to be answered by the same line. Reading the root instead made
 * `condition: { field: 'discountType' }` on a line test the *document's*
 * `discountType`. No lines section noticed, only because none of them carried a
 * condition yet (36.03 §7 B3).
 *
 * Four renderers ask this question — a field, a field inside a group, the group
 * itself, and a modal control — and they were four copies of the root-only read.
 * One helper so the scope rule is stated once.
 *
 * `$`-prefixed keys are render context rather than form state ($mode, $state).
 * They resolve to undefined in either scope and are supplied by the caller's
 * `context`, so they need no special case here.
 *
 * This calls `useStore` unconditionally, so it obeys the rules of hooks wherever
 * the caller does.
 */
const useConditionValues = (useStore, keys, lineId, path = [], subObject = null) => {
    const [values] = useStore((s) => {
        const picked = {}
        for (const field of keys) {
            picked[field] = lineId === undefined
                ? s[field]
                : getNestedValueKey(s, path, field, subObject)
        }
        return picked
    })

    return values
}

export default useConditionValues
